<template>
  <div v-if="collapsed" class="ml-3 mb-3">
    <div class="row info-container">
      <div
        v-for="(resume, index) in educationalServiceResumeDetails"
        :key="'service-details' + index"
        class="col-md-4"
      >
        <div
          class="info-container__header color-gray-2 font-14 font-weight-bold"
        >
          {{ resume.serviceTypeName }}
        </div>
        <div class="row">
          <div class="col">
            <div class="color-secondary-6 font-14">Total de Servicios</div>
            <div class="color-black font-weight-bold font-16 ml-3">
              {{ resume.serviceCount }}
            </div>
          </div>
          <div class="col">
            <div class="color-secondary-6 font-14">Monto Total</div>
            <div class="color-black font-weight-bold font-16 ml-3">
              {{ resume.serviceTotalAmount | price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="collapsed"
      class="row cursor-pointer"
      @click="$emit('on-toggle', collapsed)"
    >
      <div class="col-md-12">
        <div
          class="row collapse-container d-flex justify-content-center align-items-center"
        >
          <em class="text-white fa fa-chevron-down mr-2" />
          <span class="text-white">CERRAR</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceTypeEducationalInfoView',
  props: {
    collapsed: {
      type: Boolean,
      default: () => false,
    },
    educationalServiceResumeDetails: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.info-container {
  background: map-get($colors, 'gray-9');
  padding: 10px;
  border-radius: 5px;
  padding-top: 20px;
  &__header {
    display: block;
    border-bottom: 2px solid map-get($colors, 'gray-5');
    margin-bottom: 10px;
    padding-bottom: 5px;
  }
}
.collapse-container {
  background: map-get($colors, 'orange');
  padding: 3px;
  border-radius: 0px 0px 5px 5px;
  em {
    font-size: 12px;
  }
  span {
    font-size: 11px;
  }
}
</style>
